import { SinglePageBaseModel } from "./single-page-base.model";

export class BuyingPageModel extends SinglePageBaseModel {
  protected icon = 'shopping-cart';

  protected header = 'Tienda';
}
